import React, { useState, useEffect } from "react";
import { storage, db } from "../../firebase";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { useAuth } from "../../Auth/auth";
import { collection, query, where, getDocs, doc, setDoc  } from "firebase/firestore";

const Admin = () => {
  const [documents, setDocument] = useState(null);
  const [fileUrl, setFileURL] = useState("");
  const [users, setUsers] = useState([]);
  const { logout } = useAuth();

  const handleChange = (e) => {
    if (e.target.files[0]) {
      console.log("handle values", e.target.files);
      setDocument(e.target.files);
    }
  };

  const handleUpload = async () => {
    if (!documents || documents.length === 0) {
      alert("No files selected");
      return;
    }
  
    const storage = getStorage();
    const usersCollection = collection(db, "users");
  
    for (const document of documents) {
      const storageRef = ref(storage, `docs/${document.name}`);
      const uploadTask = uploadBytesResumable(storageRef, document);
  
      try {
        await uploadTask;
  
        const fileUrl = await getDownloadURL(storageRef);
        await setDoc(doc(usersCollection, document.name), {
          fileName: document.name,
          docs: fileUrl,
        });
        console.log(`File ${document.name} uploaded: ${fileUrl}`);
      } catch (error) {
        console.error(`Error uploading ${document.name}: ${error}`);
      }
    }
  
    alert("Files Uploaded");
  };
  

  async function handleSignout(e) {
    await logout();
    // console.log();
  }

  useEffect(() => {
    const fetchUsers = async () => {
      const q = query(collection(db, "users"));
  
      try {
        const querySnapshot = await getDocs(q);
        const userData = [];
        
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          if (doc.exists()) {
            userData.push({ ...doc.data() });
          }
        });
  
        setUsers(userData);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };
  
    fetchUsers();
  }, []);
  
 
  return (
    <div>
      <div
        className="bgded overlay"
        style={{
          backgroundImage:
            'url("https://images.unsplash.com/photo-1545043565-42d7d40b2a9a?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit&w=1050&q=80")',
        }}
      >
        {/* ################################################################################################ */}
        <div className="wrapper row0">
          <div id="topbar" className="hoc clear">
            {/* ################################################################################################ */}
            <div className="fl_left">
              {/* ################################################################################################ */}
              <ul className="nospace">
                <li>
                  <i className="fas fa-phone" /> (+91)8700230989
                </li>
                <li>
                  <i className="far fa-envelope" />
                  gautamfacilityservices@gmail.com
                </li>
              </ul>
              {/* ################################################################################################ */}
            </div>
            <div className="fl_right">
              {/* ################################################################################################ */}
              <ul className="nospace">
                <li>
                  <a href="../home">
                    <i className="fas fa-home" />
                  </a>
                </li>
                <li>
                  <a href="contact" title="Help Centre">
                    <i className="fas fa-life-ring" />
                  </a>
                </li>
                <li>
                  <a href="home" title="Sign Out" onClick={handleSignout}>
                    <i class="fas fa-sign-out-alt"></i>
                  </a>
                </li>
              </ul>
              {/* ################################################################################################ */}
            </div>
            {/* ################################################################################################ */}
          </div>
        </div>
        {/* ################################################################################################ */}
        {/* ################################################################################################ */}
        {/* ################################################################################################ */}
        <div className="wrapper row1">
          <header id="header" className="hoc clear">
            {/* ################################################################################################ */}
            <div id="logo" className="fl_left">
              <h1>
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/assets/images/demo/backgrounds/company.png"
                  }
                  style={{ width: "65px" }}
                />
                <a href="../home">Gautam Facility Services</a>
              </h1>
            </div>
            {/* ################################################################################################ */}
            <nav id="mainav" className="fl_right">
              <ul className="clear">
                <li>
                  <a href="home">Home</a>
                </li>
                <li>
                  <a href="about">About</a>
                </li>
                <li>
                  <a href="services">Our services</a>
                </li>
                <li>
                  <a href="clients">Clients</a>
                </li>
                <li>
                  <a href="compliance">Compliance</a>
                </li>
                <li>
                  <a href="whyus">Why Us?</a>
                </li>
              </ul>
            </nav>
            {/* ################################################################################################ */}
          </header>
        </div>
        {/* ################################################################################################ */}
        {/* ################################################################################################ */}
        {/* ################################################################################################ */}
        <div id="breadcrumb" className="hoc clear">
          {/* ################################################################################################ */}
          <h6 className="heading">Admin Dashboard</h6>
          {/* ################################################################################################ */}
        </div>
        {/* ################################################################################################ */}
      </div>
      {/* End Top Background Image Wrapper */}
      {/* ################################################################################################ */}
      {/* ################################################################################################ */}
      {/* ################################################################################################ */}
      <div className="wrapper row3">
        <main className="hoc container clear">
          {/* main body */}
          {/* ################################################################################################ */}
          <div className="content">
            {/* ################################################################################################ */}
            <h1>Upload Documents</h1>
            <input type="file" onChange={handleChange} multiple />

            <button onClick={handleUpload}>Upload</button>
            <br />
            <ul>
              {users.map((user) => {
                return (
                  <li key={user.name}>
                    <a
                      href={user.docs}
                      target="_blank"
                      style={{ color: "blue" }}
                    >
                      {user.fileName}
                    </a>
                    <br />
                  </li>
                );
              })}
            </ul>
          </div>
          {/* ################################################################################################ */}
        </main>
      </div>
      {/* ################################################################################################ */}
      {/* / main body */}
      <div className="clear" />
      {/* ################################################################################################ */}
      {/* ################################################################################################ */}
      {/* ################################################################################################ */}
      <div className="wrapper row4">
        <footer id="footer" className="hoc clear">
          {/* ################################################################################################ */}
          <hr className="btmspace-50" />
          {/* ################################################################################################ */}
          <div className="group">
            <div className="one_quarter first">
              <h6 className="heading">Contact info</h6>
              <ul className="nospace btmspace-30 linklist contact">
                <li>
                  <i className="fas fa-map-marker-alt" />
                  <address style={{ marginRight: "-12px" }}>
                    N-12 K.N Complex Lajpat Nagar - 2 New Delhi-110024
                  </address>
                </li>
                <li>
                  <i className="fas fa-phone" />
                  (+91)8700230989
                  <br /> (011) 29831411
                </li>
                <li>
                  <i className="far fa-envelope" /> gautamfacilityservices@gmail.com
                </li>
              </ul>
              <ul className="faico clear">
                <li>
                  <a className="faicon-facebook" href="#">
                    <i className="fab fa-facebook" />
                  </a>
                </li>
                <li>
                  <a className="faicon-google-plus" href="#">
                    <i className="fab fa-google-plus-g" />
                  </a>
                </li>
                <li>
                  <a className="faicon-linkedin" href="#">
                    <i className="fab fa-linkedin" />
                  </a>
                </li>
                <li>
                  <a className="faicon-twitter" href="#">
                    <i className="fab fa-twitter" />
                  </a>
                </li>
                <li>
                  <a className="faicon-vk" href="#">
                    <i className="fab fa-vk" />
                  </a>
                </li>
              </ul>
            </div>
            <div className="one_quarter">
              <h6 className="heading">Services</h6>
              <p className="nospace btmspace-15"></p>
              <ul className="nospace btmspace-30 linklist contact">
                <li>
                  <i className="fas fas fa-check-square" />
                  Hospital Housekeeping Services
                </li>
                <li>
                  <i className="fas fas fa-check-square" />
                  Manpower Services
                </li>
              </ul>
              <p />
            </div>
            <div className="one_quarter">
              <h6 className="heading">Read about us</h6>
              <ul className="nospace linklist">
                <li>
                  <a href="about">About</a>
                </li>
                <li>
                  <a href="profile">Company Profile</a>
                </li>
                <li>
                  <a href="clients">Clients</a>
                </li>
                <li>
                  <a href="compliance">Compliance</a>
                </li>
                <li>
                  <a href="whyus">Why Us?</a>
                </li>
              </ul>
            </div>
            <div className="one_quarter">
              <h6 className="heading">Clients</h6>
              <ul className="nospace clear latestimg">
                <li>
                  <a className="imgover" href="../pages/clients">
                    <img src="../images/demo/gallery/hospitals/7.png" alt />
                  </a>
                </li>
                <li>
                  <a className="imgover" href="../pages/clients">
                    <img src="../images/demo/gallery/hospitals/2.gif" alt />
                  </a>
                </li>
                <li>
                  <a className="imgover" href="../pages/clients">
                    <img src="../images/demo/gallery/hospitals/3.png" alt />
                  </a>
                </li>
                <li>
                  <a className="imgover" href="../pages/clients">
                    <img src="../images/demo/gallery/hospitals/4.jpeg" alt />
                  </a>
                </li>
                <li>
                  <a className="imgover" href="../pages/clients">
                    <img src="../images/demo/gallery/hospitals/5.png" alt />
                  </a>
                </li>
                <li>
                  <a className="imgover" href="../pages/clients">
                    <img
                      src="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wCEAAkGBw0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ8NDQ0NFREWFhURFRUYIywhGBolGxUWLT0hJS0rLjA6FyAzODMsNygtLisBCgoKDg0OGBAQGDclHx8rLTcwNzcwLS41NTgvNzc3MDg3LTc0KzIrLSsrKzU3NysrLS0rKzcwLy0rLSsrLSstN//AABEIAMgAyAMBEQACEQEDEQH/xAAbAAEBAQADAQEAAAAAAAAAAAABAgADBAUGB//EADYQAAIDAAECBAMEBwkAAAAAAAABAgMRBAUSEyExUQYUIkFxgaEVIzJUYZGiFjNEYnOSk6TR/8QAGAEBAAMBAAAAAAAAAAAAAAAAAAMEBQL/xAAxEQEAAQMBBAcGBwAAAAAAAAAAAQIDERIEITFBEyJRYZGhsVJxgZKiwQUUFUJDU2L/2gAMAwEAAhEDEQA/AP1NICkgKSAUgKSAcAcAcAcAcA2AbANgGwDYBsAMAMAMAGgDAJaAGgJaAloCkgKSAUgKSAUgKSAUgHAHAHANgDgGwAwDYBsAMAMAMAGgJaAGgJaAGgJaAUgKSApICkgFICkgFIBwBwBwDYA4BsA2AGAbADADADAJaAGgBoCWBLQEsCkBSApAKApAKQFJAKQDgGAcA2AbANgGAANgA0BLQA0AMCWgJYAwJYCgKQFIBQFICkAoBAcAcAcA2AbANgGwAwAAABoAaAlgSwBgSwJYCgKQFICkAoCkAgUA4A4BsAcA2AbADANgBgEsAAGgJYAwJYEsCWAoCkBSApAUgFAUgFAICA4BgHADANgBgAwACWAMAYEsCWBLAlgKApAUgKQFIBQFIBQCgKAwDgGAwAAADAGAMCWBLAGBLAlgQwFAUgLQCgKQFICkAoBAoBAwDgABgBgSwBgSwBgSwJYEsCWBLAUBSApAUgKQCgKQFIBQFAICBgADASAMAYEsCWAMCWBLAlgSwMgKQFICkBSApAeN1++yF3FUJyipQ5rkoyaUnGhuO++MgvVTFVOO/wBGhsdFNVFczGcTT6vFhzr+yL8a3fB6M98SXrOX1v8AH7fcgiurHHlSvzZt6p6scbvLs4eD7hF5gFAIFAYAAABgDAlgDAlgSwJYEsCWBLAyApAUgKQE3XQrhKyyShCK2Un5JL3A6K+IuB+90/7wPM6p1Hjcnk8KFN9djfzdbUZa050SUfzK96OtT8fRobFVi3d7tM+Ew8qpt1QcYuTfD6faopbKXy1zjbFL7Wl9hWjhHujyne1Kt1c5n91cfPG7xfWR+JOntb81Uv4N9r/FP0LfT2/aY8/h+0x/HLs8Lq3F5EnCm+u2ai5OMJa1HUt/NHdNyiqcRKK7st61GqumYhwv4j4Cm63yqozUnFqTaySeNNvyO0Dmp65wp2+DDk0ysbxRU09fsn6NgXzur8XjSUb7665SWqMpfVnvnsA8vqvGprhdZdCNVjShZvdGTabWNfwTAjg9X4vJbjRfXZJLXGMvqz3x+eAcXJ67wqrHTZyK4WRaUoybWatWv09GBXO6vxeP2eNdCvxE5Q3X3L3WfeBFXWuJOudsORXKurPEkn+xvpq9UBwQ+I+BJqMeVW3JpJefm36IC+V1vh02Oq3kVwsjmxk2s1JrfwaA7qkmk0001qa8017gDAlgSwJYGQFICkBSA4Oo93g2dvid3b5eEoys3/KpeW/eB8znK9uqf8HBA4OdVyXBycepbU/Gg508NRjZDzUn2vcI7lGqnCfZr3RV6pjMTumO2J4uOm+NuNKMJza5K4tlz4t1Vs0m7eNb6OMvXtZU5459nDwltRPV1ROYxjONUTHKKqeOY7Xe7eV7dU/6N39X2nXX7/JFmz/j648nqfD6u8aXifO9vhvPmIcaMN7o+nh+e/l6ktnVq35+OFXbOj0Rp08eWr7uj03j1z6d1NzrhJq7qDTlFNppNrzLDNcHUeJVHoVNsaq42Rr4lkbIwSmpucNlvrr1gXTx+TZzupOpcGUlbFSXMhOdiq7F25npHAOvXx1Xx+nwlbRdD9MRa8FydMYtS2C7vsT0D1euRojzOmuhVrkvkpPw1FSfH7X392fZ9/8AEDqcm7kc+rl2R+Tppg76+2VXi8iSgmtlryLf5AcfS4qVvRVJKS+Ru8pLV5RjgHoV0Qj1mcYwjGM+mqUoqKUZS8fNa+5IDdIqh+kOqfTHylw8+leX6n7AOjfbfzo8uUPlKaa5XUtTq8XkT7Fjb14tA9X4Xe8Di/6MQPTYEsCWBLAyApAUgKQE8iiFsJV2RUoTWSi/RoDzl8M9P/da/wCr/wBA8vqvS+Nxr+M6Ko1udXPUu3fPOO89fvA8x1RnXFSjGS+X6GvNJ+Tk01/I5qpirdMO6Llduc0Tie59Z/Zrp7/wlX8miP8AL2/ZWf1Daf7JdngdH4vGm7KKIVzcXFyjuuLaefkjqm1RTOaYR3dqvXY011ZhzVcCmFdlUYJV2uyVkdf1Of7T/EkV2s6dROhcaVadCUIqvZYlFpxW+vliA4eo9E4fKkp30Qsmlndsoyz2bTW/iA8no3EtphROiDprfdCtbGMXjW+X3v8AmAdP6NxOK3KiiFcmsclrlntr8wOHl/DvAunKyzjVynJ7KS7o9z93j9QOxV02iDplGtJ0QlXU9l9EH6oC/la/G8ftXjeH4Xfr3w+7u7c9PUAq4tcLLbYxSsu7PElr+vtWR/IDocv4f4V03ZZx4SnLzlL6ouT93j9QO7x6IVQjXXHthBZGK14vxAtgSwJYEMDICkBSApAUgKQHifEFM5XcVxhKSjXzk3GLaTdDS3PdgeLDiXdkf1Vn9z0RfsS9YS+pfh9vsB9ygEBAdA2gYAAABgDAlgDAlgSwJYEsCWBkBSApAKApAUgFAUgEBAQNoDoBoGAABgDAlgDAlgSwJYEsCWBkBSApAUgFAUgFAUgHQEB0DaBtA2gbQAAAAJYAwJYEsAYEsCWAICkBSApAKApAICA6A6A6BtA2gbQNoBoAAAAAwJYEsAYEsCWAICkBSAUBSAUwKTAdAdAdA2gOgbQNoBoG0AANAGwJYAwJYEsAYEsCUBSApAUmApgUmApgOgOgOgOgYDaBgDQNoBoBoA2ANgS2ANgS2BLYEsAQFJgUgFMCkwFMB0B0B0B0B0DaBtA2gbQDQDQDQDQBsAbAlsAbAlsCWwBMBTApMCkwFMBTArQHQNoDoDoG0DaBtA2gGgGgbQDQJbAGwJbAGwJbAlsATApMBTApMBTApMB0B0DaA6A6BtA2gbQNoBoBoG0A0CWwBsAbAlsAbAlsCUwKTApMBTAUwKTAdAdA2gOgbQHQNoG0A0DaAaBtANAGwJ0AbAlsAbAlsATAUwKTAUwFMB0CtA2gOgOgbQNoG0DaBtA2gGgGgGgDYBoA2ANgS2BLYH//2Q=="
                      alt
                    />
                  </a>
                </li>
                <li>
                  <a className="imgover" href="../pages/clients">
                    <img src="/images/demo/gallery/hospitals/01.png" alt />
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {/* ################################################################################################ */}
        </footer>
      </div>
    </div>
  );
};

export default Admin;
